"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Layout = _interopRequireDefault(require("../Layout"));

var _RichTypography = _interopRequireDefault(require("../RichTypography"));

var _excluded = ["children", "className", "title", "titleProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: "border-box",
      display: "block",
      // Fix IE 11 layout when used with main.
      marginLeft: "auto",
      marginRight: "auto",
      minWidth: typography.pxToRem(360),
      padding: "0 ".concat(typography.pxToRem(15)),
      width: "100%"
    },
    title: {}
  };
});

var Section = /*#__PURE__*/_react["default"].forwardRef(function Section(_ref2, ref) {
  var children = _ref2.children,
      className = _ref2.className,
      title = _ref2.title,
      titleProps = _ref2.titleProps,
      props = _objectWithoutProperties(_ref2, _excluded);

  var classes = useStyles(props);

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_Layout["default"], _extends({}, props, {
    className: (0, _clsx["default"])(classes.root, className),
    ref: ref
  }), title !== null && title !== void 0 && title.length ? /*#__PURE__*/_react["default"].createElement(_RichTypography["default"], _extends({
    variant: "h2",
    className: classes.title
  }, titleProps), title) : null, children);
});

Section.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  classes: _propTypes["default"].shape({
    root: _propTypes["default"].string,
    fixed: _propTypes["default"].string
  }),
  title: _propTypes["default"].string,
  titleProps: _propTypes["default"].shape({})
};
Section.defaultProps = {
  classes: undefined,
  className: undefined,
  title: undefined,
  titleProps: undefined
};
var _default = Section;
exports["default"] = _default;